import React, { FC } from 'react'

import { XMarkIcon } from '@heroicons/react/20/solid'

import { DOCUMENT_OPTIONS } from '@/constants/documents'
import { DownloadOptionType } from '@/features/DealSummary/dropDownMenuItems'
import { useDeleteUserDocumentMutation } from '@/services/documents'
import { UserDocument } from '@/types/unlock'

export type DownloadSectionModal = {
  onClose: () => void
  onDownload: () => void
  data?: { option: Partial<DownloadOptionType>; docs: UserDocument[] }
}

export const DownloadSectionModal: FC<DownloadSectionModal> = (props) => {
  const { onClose, onDownload, data } = props

  const [deleteDoc] = useDeleteUserDocumentMutation()

  const { option, docs } = data

  const count = docs.length

  const { documentType } = option

  const docName =
    documentType === DOCUMENT_OPTIONS.INITIAL_APPLICATION_UNLOCK_AGREEMENT
      ? 'Initial Application'
      : documentType === DOCUMENT_OPTIONS.FINAL_APPLICATION_FOR_UNLOCK_AGREEMENT
        ? 'Final Application'
        : documentType === DOCUMENT_OPTIONS.INVESTMENT_ESTIMATE
          ? 'IE'
          : 'ICS'

  const text =
    count === 1
      ? `A previous ${docName} version already exists. Do you want to replace it?`
      : `Previous ${docName} versions already exist. Do you want to replace them?`

  const handleDownload = async () => {
    onClose()
    await onDownload()
  }

  const handleOverwrite = async () => {
    await handleDownload()
    docs.forEach((file) => deleteDoc(file.uuid))
  }

  return (
    <div
      id='overlay'
      className='visible top-0 left-0 fixed w-screen h-screen bg-gray-400/60 z-50 flex items-center justify-center'
    >
      <div className='flex flex-col gap-4 w-[40%] bg-white rounded py-4'>
        <div className='flex justify-between border-b-2 px-4 pb-2'>
          <h4 className='font-bold'>Confirm Download to Document Vault</h4>
          <XMarkIcon
            className='cursor-pointer'
            width={20}
            onClick={() => onClose()}
          />
        </div>
        {/* Main Content */}
        <div className='px-8'>
          <div className='flex py-4 px-4 flex-col'>
            <p>{text}</p>
          </div>
          <div className='flex justify-between items-end px-4'>
            <p
              className='text-sm hover:underline cursor-pointer'
              onClick={() => onClose()}
            >
              Cancel
            </p>
            <div className='flex gap-8'>
              <button
                className='rounded bg-blue-600 disabled:bg-sky-300 text-white py-2 px-4'
                type='button'
                disabled={false}
                onClick={() => handleOverwrite()}
              >
                Yes
              </button>
              <button
                className='rounded bg-blue-600 disabled:bg-sky-300 text-white py-2 px-4'
                type='button'
                disabled={false}
                onClick={() => handleDownload()}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
